import { PERPS_RECENT_FILLS_LIMIT, PERPS_RECENT_TRADES_LIMIT } from '@/lib/hyperliquid/constants';
import type { PerpFill, PerpTrade } from '@/lib/hyperliquid/types';

// Hyperliquid identifies a trade by (block time, coin, tid). The two sides of a
// self-trade can share that identity, so user fills also include the order id.
const tradeKey = (trade: PerpTrade) => `${trade.time}:${trade.coin}:${trade.tid}`;
export const fillKey = (fill: PerpFill) => `${fill.time}:${fill.coin}:${fill.tid}:${fill.oid}`;

export function mergeTrades(
  current: readonly PerpTrade[] | undefined,
  incoming: readonly PerpTrade[],
): PerpTrade[] {
  const trades = new Map<string, PerpTrade>();
  // A batch is oldest-first, including fills within the same millisecond. `tid`
  // is a hash, so sorting by it would scramble consecutive fills on the tape.
  for (const trade of [...incoming].reverse().concat(current ?? [])) {
    const key = tradeKey(trade);
    if (!trades.has(key)) trades.set(key, trade);
  }
  return [...trades.values()].sort((a, b) => b.time - a.time).slice(0, PERPS_RECENT_TRADES_LIMIT);
}

export function mergeFills(
  current: readonly PerpFill[] | undefined,
  incoming: readonly PerpFill[],
): PerpFill[] {
  const fills = new Map((current ?? []).map((fill) => [fillKey(fill), fill]));
  for (const fill of incoming) fills.set(fillKey(fill), fill);
  return [...fills.values()]
    .sort((a, b) => b.time - a.time || b.tid - a.tid)
    .slice(0, PERPS_RECENT_FILLS_LIMIT);
}
